module.exports = {
    "dismiss": `Zru\u{161}i\u{165}`
};


//# sourceMappingURL=sk-SK.main.js.map
